// extracted by mini-css-extract-plugin
module.exports = {"intro":"TestimonianzeSection_intro__MywOI","title":"TestimonianzeSection_title__tObZe","list":"TestimonianzeSection_list__KNlW4","item":"TestimonianzeSection_item__l46TA"};